module.exports = __webpack_public_path__ + "static/media/Fresh-Mango-Tower-768x631.a0ae1310.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/cta/Fresh-Mango-Tower-768x631.png
// module id = 109
// module chunks = 0